/**
 * Returns a server version from a save result only when the save succeeded.
 * Conflicts and explicit unsuccessful responses must not advance local refs,
 * otherwise subsequent saves can bypass optimistic concurrency checks.
 *
 * @param {*} result
 * @param {string} versionField
 * @returns {number|null}
 */
export function getVersionFromSaveResult(result, versionField) {
    if (!result || typeof result !== "object") return null
    if (result.conflict) return null
    if (result.stale) return null
    if (result.success === false) return null
    const version = result[versionField]
    if (version == null) return null
    // GraphQL JSONObject scalars may stringify numbers during serialization;
    // coerce back to a number so downstream Int variables aren't rejected.
    const numeric = Number(version)
    return Number.isInteger(numeric) ? numeric : null
}
